import React from 'react'
import {LeftColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import styled from 'styled-components'
import {currentMedia, HideInPC, HideInSP} from '../../../../styledComponents/ResponsiveConvenience'
import moment from 'moment/moment'
import {Box} from '@mui/material'
import {StyledLink} from '../../../../styledComponents/residentPage/Links'
import {Messages} from '../../../../Messages'
import {getLinkIconComponent} from '../common/NatResidentAssocWorkReportsCommon'
import {getFileExtension} from '../../../common/util/Natutil'

interface Props {
    mergeFileType: string,
    currentMoment: moment.Moment,
    onMergedFileClick: () => Promise<void>
    totalFileSizeKB: number,
    mergedFileName: string,
}

export const NatResidentMergedReportFileComponent: React.FC<Props> = props => {
    const {
        mergeFileType,
        currentMoment,
        onMergedFileClick,
        totalFileSizeKB,
        mergedFileName,
    } = props
    const fileSizeOverFlag = totalFileSizeKB > 200 * 1024
    const mergedFileSizeText = totalFileSizeKB >= 1024
        ? `${Math.round(totalFileSizeKB / 1024)}MB`
        : `${totalFileSizeKB}KB`

    const errorMessageText = Messages.EREPR0001.toString()

    const renderMergedFileForPC = () => {
        return <>
            <MergedFileInfoText>
                <LinkButton
                    onClick={() => onMergedFileClick()}
                    disabled={fileSizeOverFlag}
                >
                    <StyledFileName>
                        {mergedFileName}
                    </StyledFileName>
                </LinkButton>
                <Box width={'8px'}/>
                <StyledFileSize>
                    (約{mergedFileSizeText})
                </StyledFileSize>
            </MergedFileInfoText>
            {fileSizeOverFlag && <ErrorMessage>
                {errorMessageText}
            </ErrorMessage>}
        </>
    }

    const renderMergedFileForSP = () => {
        return <LinkButtonForSP onClick={() => onMergedFileClick()} disabled={fileSizeOverFlag}>
            <StyledFileIcon>
                {getLinkIconComponent(getFileExtension(mergedFileName))}
            </StyledFileIcon>
            <LeftColumnFlexContainer>
                <StyledFileName>
                    {mergedFileName}
                </StyledFileName>
                <StyledFileSize>
                    約{mergedFileSizeText}
                </StyledFileSize>
                {fileSizeOverFlag && <ErrorMessage>
                    {errorMessageText}
                </ErrorMessage>}
            </LeftColumnFlexContainer>
        </LinkButtonForSP>
    }

    return <MergedReportFileArea>
        <MergeDescription>
            {mergeFileType}を一つのファイルにまとめてダウンロードできます。
        </MergeDescription>
        <NotesDescription>
            ※{currentMoment.format('YYYY年M月D日')}時点で提出されている報告書が対象となります。
        </NotesDescription>
        <HideInPC>
            <NotesDescription>
                ※ファイルサイズが大きい場合は、Wi-Fi環境下での閲覧を推奨します。
            </NotesDescription>
        </HideInPC>
        <Box height={'20px'}/>
        <HideInSP>
            {renderMergedFileForPC()}
        </HideInSP>
        <HideInPC>
            {renderMergedFileForSP()}
        </HideInPC>
    </MergedReportFileArea>
}

const MergedReportFileArea = styled(LeftColumnFlexContainer)`
  margin: 15px;
`

const MergeDescription = styled.div`
  font-size: ${FontSize.Middle};
`

const NotesDescription = styled.div`
  font-size: ${FontSize.Small};
`

const MergedFileInfoText = styled(LeftRowFlexContainer)`
  align-items: baseline;
`

const LinkButton = styled(StyledLink)<{ disabled?: boolean }>`
  color: ${props => props.disabled ? Colors.Body : Colors.Primary};
`

const StyledFileName = styled.div`
  font-size: ${FontSize.Middle};
  ${currentMedia.lessThan('sp')`
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     color: ${Colors.Body};
  `};
`

const StyledFileSize = styled.div`
  font-size: ${FontSize.Small};
  color: ${Colors.AccentDark};
  white-space: nowrap;
`

const ErrorMessage = styled.div`
  font-size: ${FontSize.Small};
  color: ${Colors.Alert};
`

const LinkButtonForSP = styled(LinkButton)<{ disabled?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  padding: 10px;
  border: 1px solid ${Colors.AccentLight};
  border-radius: 4px;
  ${props => props.disabled && `
    　background: ${Colors.AccentLight};
  `};
`

const StyledFileIcon = styled.div`
  font-size: 21px;
  line-height: 1;
  min-width: 21px;
  text-align: center;
  margin-right: 10px;
  color: ${Colors.AccentDark};
`
